import React from "react";
import { object, number, string, array } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";

import "./photo-story-card.m.css";

const PhotoStoryCard = ({
  story,
  headerLevel,
  headlineType,
  imageType,
  aspectRatio,
  headlineClassName,
  cardImageWidths,
  headlineStyle = ""
}) => {
  return (
    <Link href={story.url} className="wrapper">
      <div styleName="base">
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          widths={cardImageWidths}
          imageType={imageType}
          zoom={false}
          showAlternateImage={true}
        />
        <div styleName="card-content" className="card-content">
          <Headline
            text={story.headline}
            headlineType={headlineType}
            headerLevel={headerLevel}
            className={headlineClassName}
            styleName={headlineStyle}
          />
        </div>
      </div>
    </Link>
  );
};

PhotoStoryCard.defaultProps = {
  imageType: "image16x9",
  aspectRatio: [16, 9],
  headlineClassName: ""
};

PhotoStoryCard.propTypes = {
  story: object.isRequired,
  headerLevel: number,
  headlineType: number,
  imageType: string,
  headlineClassName: string,
  aspectRatio: array,
  cardImageWidths: array,
  headlineStyle: string
};

export default PhotoStoryCard;
